export const isMobile = () => {
  const mediaQueryList = window.matchMedia('screen and (max-width: 767px)');
  return mediaQueryList.matches;
};

export function isInAppBrowser(): boolean {
  const isIphone = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
    navigator.userAgent,
  );

  const isAndroid = /(Android).*Version\/[\d.]+.*Chrome\/[^\s]+ Mobile/i.test(
    navigator.userAgent,
  );

  return isIphone || isAndroid;
}
